<template>
  <div class="cert-section">
    <div class="section-head">
      <span class="section-label">Chứng thư số</span>
      <span v-if="certInfo" class="status-pill ok">Hợp lệ</span>
      <span v-else-if="connectionStatus === false" class="status-pill err">Lỗi</span>
    </div>

    <button class="connect-btn" :disabled="loading" @click="checkAndLoadCert">
      <svg v-if="!loading" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clip-rule="evenodd"/></svg>
      <span v-if="loading" class="mini-spin"></span>
      {{ loading ? 'Đang kết nối...' : (certInfo ? 'Kết nối lại' : 'Kết nối USB Token') }}
    </button>

    <div v-if="error" class="err-msg">{{ error }}</div>

    <div v-if="certInfo" class="cert-card">
      <div class="cert-name">{{ certDisplayName }}</div>
      <div class="cert-grid">
        <div class="cert-field"><span>Email</span><span>{{ certInfo.Email || '--' }}</span></div>
        <div class="cert-field"><span>Serial</span><span class="mono">{{ certInfo.SerialNumber }}</span></div>
        <div class="cert-field"><span>Issuer</span><span>{{ certInfo.Issuer }}</span></div>
        <div class="cert-field"><span>Hết hạn</span><span>{{ certInfo.ValidTo }}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import vgcaService from '@/services/vgcaService'

export default {
  name: 'SignProviderSelector',
  data() {
    return {
      provider: 'VGCA',
      loading: false,
      connectionStatus: null,
      certInfo: null,
      error: null
    }
  },
  computed: {
    certDisplayName() {
      if (!this.certInfo) return ''
      return vgcaService.parseCertSubject(this.certInfo.Subject)
    }
  },
  methods: {
    async checkAndLoadCert() {
      this.loading = true
      this.error = null
      this.certInfo = null
      try {
        this.$emit('log', '[SignProvider] Kiểm tra kết nối VGCASignService...')
        const isAvailable = await vgcaService.checkAvailability()
        this.connectionStatus = isAvailable
        if (!isAvailable) {
          this.error = 'Không kết nối được VGCASignService. Kiểm tra ứng dụng + USB Token.'
          this.$emit('log', '[SignProvider] FAIL - VGCASignService không chạy')
          return
        }
        this.$emit('log', '[SignProvider] OK - VGCASignService đang chạy')
        this.$emit('log', '[SignProvider] Đang lấy chứng thư số từ USB Token...')
        const result = await vgcaService.getCertificates()
        this.certInfo = result.CertInfo
        this.$emit('log', '[SignProvider] OK - Chứng thư số: ' + this.certDisplayName)
        this.$emit('cert-loaded', result.CertInfo)
      } catch (err) {
        this.error = err.message
        this.$emit('log', '[SignProvider] LOI: ' + err.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.section-head { display:flex; align-items:center; gap:8px; margin-bottom:10px; }
.section-label { font-size:13px; font-weight:600; color:#1e293b; }
.status-pill {
  font-size:10px; font-weight:600; padding:2px 8px; border-radius:999px;
  text-transform:uppercase; letter-spacing:0.5px;
}
.status-pill.ok { background:#d1fae5; color:#065f46; }
.status-pill.err { background:#fee2e2; color:#991b1b; }

.connect-btn {
  width:100%; padding:8px 12px; border:1px solid #e2e8f0; border-radius:6px;
  background:#f8fafc; color:#334155; font-size:13px; font-weight:500; font-family:inherit;
  cursor:pointer; display:flex; align-items:center; justify-content:center; gap:6px;
  transition:all 0.2s;
}
.connect-btn:hover:not(:disabled) { background:#f1f5f9; border-color:#cbd5e1; }
.connect-btn:disabled { opacity:0.5; cursor:not-allowed; }
.connect-btn svg { width:14px; height:14px; }
.mini-spin {
  width:14px; height:14px; border:2px solid #cbd5e1;
  border-top-color:#00568c; border-radius:50%;
  animation:spin 0.6s linear infinite;
}
@keyframes spin { to{transform:rotate(360deg)} }

.err-msg {
  margin-top:8px; padding:6px 10px; background:#fef2f2;
  border:1px solid #fecaca; border-radius:4px;
  font-size:12px; color:#991b1b;
}

.cert-card {
  margin-top:10px; padding:10px 12px;
  background:#f0fdf4; border:1px solid #bbf7d0; border-radius:8px;
}
.cert-name { font-size:14px; font-weight:600; color:#166534; margin-bottom:8px; }
.cert-grid { display:grid; gap:4px; }
.cert-field {
  display:flex; justify-content:space-between; gap:8px;
  font-size:11px; line-height:1.5;
}
.cert-field span:first-child { color:#64748b; white-space:nowrap; }
.cert-field span:last-child { color:#334155; text-align:right; word-break:break-all; }
.mono { font-family:'JetBrains Mono',monospace; font-size:10px; }
</style>
